import type { RCEVoucherPresentation } from './rceVoucherPresentation'
import type { RCEVoucherTopCandidate } from '../VoucherBanner.types'

interface ResolveRCEVoucherTopCandidateInput {
  presentation: RCEVoucherPresentation
  isActivated: boolean
  hiddenReason: Extract<RCEVoucherTopCandidate, { kind: 'hidden' }>['reason']
}

export const resolveRCEVoucherTopCandidate = ({
  presentation,
  isActivated,
  hiddenReason
}: ResolveRCEVoucherTopCandidateInput): RCEVoucherTopCandidate => {
  switch (presentation.kind) {
    case 'variant-b-edit':
      return {
        kind: 'rce-variant-b-edit',
        amount: presentation.amount,
        isActivated
      }
    case 'variant-c-edit':
      return {
        kind: 'rce-variant-c-edit-notice',
        amount: presentation.amount
      }
    case 'activated-additional':
      return {
        kind: 'rce-activated-additional',
        amount: presentation.amount,
        variant: presentation.variant
      }
    default:
      return { kind: 'hidden', reason: hiddenReason }
  }
}
